<template lang="pug">
.label-text-required
  strong
    span(:class="{'red-color': rs.invalid()}")
      span(
        data-balloon-pos="up",
        :aria-label="isPresent(rs.section.tooltip) ? rs.section.tooltip : null"
      )
        | {{rs.section.name}}
        span(v-if="rs.invalid()" v-html="invalid_section_tooltip(rs.age_invalid, rs.grade_invalid)")
</template>

<script>
import helpers from '../helper'
export default {
  name: "registration-section-section_name",
  mixins: [helpers],
  props: ['rs']
}

</script>